import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AppSettings} from '../../../app-settings';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs/Subject';
import {DataManagementService} from '../../services/data-management.service';
import {Constants} from '../../constants';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import {Student} from '../../model/student';
import {Router} from '@angular/router';
import {AccessService} from '../../services/access.service';
import {AuthenticationService} from '../../services/authentication.service';
import {DataTableDirective} from 'angular-datatables';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.css']
})
export class StudentsComponent implements OnInit {
  @ViewChild('uploadStudentsModal') uploadStudentsModal: TemplateRef<any>;
  @ViewChild('editStudentsModal') editStudentsModal: TemplateRef<any>;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  studentsTemplate = AppSettings.OUTGOING_STUDENT_TEMPLATE;
  public modalReference: NgbModalRef;
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  students: Student[];
  batchFilterArray: Array<any> = [];
  data: object;
  userRoleId;
  batch: any = 0;
  errorMessage: string = undefined;
  oneStudent;
  token;

  selectUndefinedOptionValue = undefined;

  constructor(private modal: NgbModal,
              private router: Router,
              private dmService: DataManagementService,
              private authenticationService: AuthenticationService,
              private accessService: AccessService) {
  }

  getStudents() {
    this.dmService.getOne(Constants.STUDENT, this.userRoleId + '/' + this.batch)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.students = response.data.students;
                this.batch = response.data.batch;
                if (this.students.length === 0) {
                  this.errorMessage = 'There is no data available for Outgoing Students.';
                } else {
                    this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team.';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getAllBatch() {
    this.dmService.getAll(Constants.OUTGOING_BATCH).subscribe(response => {
      if (response.status === 'success') {
        this.batchFilterArray = response.data.batches;
      } else {
        this.batchFilterArray = [];
      }
    },
    error => {
      console.log(error);
      // this.errorMessage = error;
    });
  }

  fileChange(evt) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot upload multiple files on the entry');
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {type: 'binary'});
      /* grab first sheet */
      const wsName = wb.SheetNames[0];
      const ws = wb.Sheets[wsName];
      /* save data */
      this.data = XLSX.utils.sheet_to_json(ws,
          {header: ['registration_id', 'name', 'email', 'programme_name', 'gender_name', 'batch', 'cgpa', 'work_experience'], range: 1});
    };
    reader.readAsBinaryString(target.files[0]);
    return this.data;
  }

  uploadStudents(e) {
    e.preventDefault();
      const finalUploadData = {
      data: this.data,
      user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
    };
    const that = this;
    let uploadResponse;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to upload ' + Object.keys(this.data).length + ' Students?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.bulkUpload(finalUploadData, Constants.STUDENT).subscribe(data => {
            uploadResponse = data;
            resolve(uploadResponse);
          }, error => {
            uploadResponse = error;
            reject(uploadResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      console.log(result);
      if (result.hasOwnProperty('value')) {
        if (uploadResponse.status === 'success') {
          that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
              that.router.navigate(['data/outgoing-students']));
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({
              title: 'Success',
              type: 'success',
              html: uploadResponse.data.message,
            });
          } else {
            Swal({
              title: 'Success',
              type: 'success',
              html: '<p>Successfully uploaded Students.</p>',
            });
          }
          that.closeModal();
        } else if (uploadResponse.status === 'fail') {
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({type: 'error', title: 'Fail', html: uploadResponse.data.message});
          } else {
            Swal({type: 'error', title: 'Fail', text: 'Unable to upload Students, Please contact support team.'});
          }
        }
      }
    }).catch(errors => {
      Swal({type: 'error', title: 'Fail', text: 'Server Error: ' + errors.message});
    });
  }

  clearStudents(): void {
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to Clear Students?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    });
  }

  rerender(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.students = [];
      this.getStudents();
    });
  }

  editStudent(): void {
    localStorage.setItem('students', JSON.stringify(this.students));
    Swal({title: 'Success', type: 'success', text: 'Student details successfully updated.', timer: 1500});
    this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
        this.router.navigate(['data/outgoing-students']));
    this.students = JSON.parse(localStorage.getItem('students'));
    this.closeModal();
  }

  deleteStudent(student): void {
    const that = this;
    Swal({
      title: 'confirm',
      type: 'question',
      text: 'Do you want to delete this student?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: function() {
        return new Promise(function (resolve, reject) {
          const index = that.students.indexOf(student);
          that.students.splice(index, 1);
          localStorage.setItem('students', JSON.stringify(that.students));
          resolve(true);
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      if (result.value === true) {
        that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
            that.router.navigate(['data/outgoing-students']));
        Swal({
          title: 'Success',
          type: 'success',
          width: 600,
          padding: 80,
          showCancelButton: false,
          showConfirmButton: true,
          html: '<p>Successfully deleted the student.</p>',
          timer: 1500
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
      console.log(error);
    });
  }

  openStudentsUploadModal() {
    this.modalReference = this.modal.open(this.uploadStudentsModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  openStudentEditModal(student) {
    this.oneStudent = student;
    this.modalReference = this.modal.open(this.editStudentsModal, {size: 'lg', backdrop: 'static', keyboard: false});
  }

  closeModal(): void {
    this.modalReference.close();
  }

  canAccessOIA() {
    return this.accessService.canAccessOIA();
  }

  canAccessEC() {
    return this.accessService.canAccessEC();
  }

  ngOnInit() {
    this.userRoleId = JSON.parse(localStorage.getItem('epas_user')).user_role_id;
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
    this.getAllBatch();
    this.getStudents();
    this.token = this.authenticationService.getToken();
  }

}


